import React, { useState, useEffect } from 'react';
import { get, post, put } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon } from '../icons';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import { FiTrash2 } from 'react-icons/fi';
import Breadcrumb from '../../components/Breadcrumb';

const FestivalDates = () => {
  const formFields = {
    festivalId: '',
    dates: [{ date: '' }],
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [festivalDateList, setFestivalDateList] = useState([]);
  const [formDetails, setFormDetails] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [query, setQuery] = useState('');
  const [festivalList, setFestivalList] = useState([]);
  const [modalMode, setModalMode] = useState(0); //0 for Add, 1 for edit

  const handleShow = () => {
    setModalMode(0);
    setShowConfirmModel(true);
    setFormDetails(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    setModalMode(1);
    try {
      get(`/fest/festival-dates/?id=${id}`).then((item) => {
        if (item?.data?.rows?.length) {
          const itemData = item.data.rows[0];
          const data = {
            festivalId: itemData?.id,
            dates: [
              ...itemData.FestivalDates.map((item) => {
                return { date: item?.date };
              }),
            ],
          };
          setFormDetails({ ...data });
          setShowConfirmModel(true);
        } else {
          toast.error('Invalid id');
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const handleDate = (index, field, value) => {
    const _formDetails = { ...formDetails };
    const dates = [..._formDetails.dates];
    dates[index][field] = value;
    setFormDetails({ ..._formDetails, dates });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (modalMode === 1) {
      try {
        await put(formDetails, '/fest/festival-dates/' + formDetails.festivalId);
        toast.success('Festival Date updated successfully');
        setShowConfirmModel(false);
        getFestivalDates();
        clearForm();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 3000 });
      }
    } else {
      try {
        await post(formDetails, '/fest/festival-dates');
        toast.success('Festival Date added successfully');
        clearForm();
        setShowConfirmModel(false);
        getFestivalDates();
      } catch (err) {
        toast.error(err.response.data.message || err.response.data.data.message || err.message, { autoClose: 2000 });
      }
    }
  };

  function getFestivalDates() {
    try {
      get(`/fest/festival-dates/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}`).then((response) => {
        setFestivalDateList(response.data.rows);
        setTotalRecords(response.data.count ?? 0);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  function getFestivals() {
    try {
      get(`/fest/festival/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}`).then((response) => {
        setFestivalList(response.data.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getFestivalDates();
      }
    },
    [query],
    DEBOUNCE_DELAY
  );

  const clearForm = () => {
    setFormDetails(formFields);
  };

  useEffect(() => {
    getFestivalDates();
    getFestivals();
  }, []);

  const handleSelect = (e) => {
    const { value, name } = e.target;
    setFormDetails((state) => {
      return { ...state, [name]: value };
    });
  };

  const addDate = () => {
    const _formDetails = { ...formDetails };
    const dates = [..._formDetails.dates];
    dates.push({ date: '' });
    setFormDetails({ ..._formDetails, dates });
  };

  const removeDate = (indexToRemove) => {
    const _formDetails = { ...formDetails };
    const dates = [..._formDetails.dates];
    dates.splice(indexToRemove, 1);
    setFormDetails({ ..._formDetails, dates });
  };

  return (
    <>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Festival' },
          { link: '#', title: 'Master' },
          { link: '#', title: 'Festival Dates' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Festival Dates | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by name"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
              Add Festival Date
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Festival</th>
                    <th>Date</th>
                    <th>Created By</th>
                    <th>Updated By</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {festivalDateList?.map((item, index) => {
                    const rowSpan = item?.FestivalDates?.length;
                    return (
                      <>
                        <tr key={item?.id}>
                          <td rowSpan={rowSpan}>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          <td rowSpan={rowSpan}>
                            {item?.name} - {item?.year}
                          </td>
                          <td>{item?.FestivalDates && item?.FestivalDates[0]?.date}</td>
                          <td>{item?.FestivalDates && item?.FestivalDates[0]?.createdByUser?.name}</td>
                          <td>{(item?.FestivalDates && item?.FestivalDates[0]?.updatedByUser?.name) || '-'}</td>
                          <td rowSpan={rowSpan} className="actions">
                            <span className="edit-icon" onClick={(e) => handleEdit(e, item?.id)}>
                              <EditIcon style={{ color: 'teal' }} />
                            </span>
                          </td>
                        </tr>
                        {item?.FestivalDates?.slice(1)?.map((data) => {
                          return (
                            <tr key={data.date + index}>
                              <td>{data?.date}</td>
                              <td>{data?.createdByUser?.name}</td>
                              <td>{data?.updatedByUser?.name || '-'}</td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{modalMode === 1 ? 'Edit Festival Date' : 'Add Festival Date'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <Row>
              <Col xs={12}>
                <FloatingLabel label="Festival" className="mb-3">
                  <select
                    required
                    name="festivalId"
                    value={formDetails.festivalId}
                    onChange={handleSelect}
                    aria-label="Floating label select example"
                    className="form-select"
                  >
                    <option value="">Select Festival</option>
                    {festivalList.map((item, index) => (
                      <option key={index} value={item?.id}>
                        {item?.name} - {item?.year}
                      </option>
                    ))}
                  </select>
                </FloatingLabel>
              </Col>
              {formDetails?.dates?.map((date, index) => {
                return (
                  <>
                    <Col xs={11}>
                      <FloatingLabel controlId="floatingInput" label="Date" className="mb-3">
                        <Form.Control
                          className="input"
                          value={date.date}
                          name="date"
                          onChange={(e) => {
                            handleDate(index, 'date', e.target.value);
                          }}
                          type="date"
                          placeholder="Date"
                          required
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={1} className="align-middle">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <FiTrash2
                          style={{ fontSize: '20px', cursor: 'pointer' }}
                          color="red"
                          title="Remove Item"
                          className="react-icons red mt-2"
                          onClick={() => {
                            removeDate(index);
                          }}
                        />
                      </div>
                    </Col>
                  </>
                );
              })}
            </Row>
            <div className="container text-center">
              <Button variant="secondary" size="sm" onClick={addDate}>
                + Add Date
              </Button>
              <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
                {modalMode === 1 ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FestivalDates;
